import React, { FC } from 'react';

import { Button2, Stack, Typography } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';
import { useAction } from 'Modules/core/redux';

import styles from './index.module.scss';
import { useModalContext } from '../Messaging';
import { messagingActions } from '../../state/actions';


export interface ErrorModalProps {
    errorText: string;
}
const ErrorModalComponent: FC<ErrorModalProps> = ({ errorText }) => {
    const { t } = useTranslation('errorModal');
    const { modal } = useModalContext();
    const close = useAction(() => messagingActions.hideMessage(modal.id), [modal.id]);
    return (
        <Stack
            py={10}
            px={8}
            spacing={8}
            alignItems='flex-start'
            bgcolor='grayscale.shade0'
            borderRadius={2.5}
            maxWidth={({ spacing }) => spacing(120)}
        >
            <Typography variant='mediumHeader1'>
                {errorText ?? t('unknownError')}
            </Typography>
            <Button2 variantType='brand' onClick={close} data-testid='button-close'>
                {t('close')}
            </Button2>
        </Stack>
    );
};

export const ErrorModal = {
    component: ErrorModalComponent,
    containerClass: styles.modal,
    position: 'center',
};
